import { getFirstPathnameSegment } from "./url";

export const isCv1Page = () => {
  let isCv1 = false;

  const scriptTags = document.head.getElementsByTagName("script");

  const targetSrc = "/_layouts/Mdc";
  const targetSrc2 = "/_layouts2/Mdc";
  const targetType = "text/javascript";

  for (let i = 0; i < scriptTags.length; i++) {
    const attribute = scriptTags[i].getAttribute("src");
    if (
      attribute &&
      (attribute.includes(targetSrc) ||
        (attribute.includes(targetSrc2) &&
          scriptTags[i].getAttribute("type") === targetType))
    ) {
      isCv1 = true;
      break;
    }
  }
  return isCv1;
};

export const isCreditRatingsPage = (): boolean => {
  const firstPathnameSegment = getFirstPathnameSegment(
    window.location.pathname
  );
  return firstPathnameSegment === "credit-ratings";
};

export const adobeAnalyticsPageLoadAlreadyTriggered = () => {
  return (
    window.digitalData?.pageInstanceID !== undefined &&
    window.digitalData?.pageInstanceID !== ""
  );
};
